export const historiqueS = {
  icon: 'fas fa-history',
  text: 'list_log',
  link: 'logs',
}
